import * as React from 'react';

import { MenuEntry } from '@europrocurement/flexy-components';
import { REALM_INTERN } from '@europrocurement/l2d-keycloak';
import TachesRoot from './views/TachesRoot';
import {
    listeDossierTachesPath,
    listeTiersTachesPath,
    listeUserTachesPath,
    tachesBasePath,
} from './constants/paths';
import { ListeTachesDossiers, ListeTachesPrescripeurs, ListeTachesUtilisateur } from './views';

export const TachesRouter = {
    path: tachesBasePath,
    element: <TachesRoot />,
    children: [
        {
            path: listeDossierTachesPath,
            element: <ListeTachesDossiers />,
        },
        {
            path: listeTiersTachesPath,
            element: <ListeTachesPrescripeurs />,
        },
        {
            path: listeUserTachesPath,
            element: <ListeTachesUtilisateur />,
        },
    ],
};

const VALID_ROLES = [REALM_INTERN];
// Administration Sub-menu entry.
export const TachesMenuEntries: MenuEntry[] = [
    {
        title: 'Taches',
        icon: 'tasks',
        role: VALID_ROLES,
        children: [
            {
                title: 'Taches liées aux dossiers',
                icon: 'fa-folder-check',
                href: listeDossierTachesPath,
                role: VALID_ROLES,
            },
            {
                title: 'Taches liées aux prescripteurs',
                icon: 'fa-building-circle-check',
                href: listeTiersTachesPath,
                role: VALID_ROLES,
            },
            {
                title: 'Mes taches',
                icon: 'fa-user-check',
                href: listeUserTachesPath,
                role: VALID_ROLES,
            },
        ],
    },
];
